import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "cart-item" };
const _hoisted_2 = { class: "cart-item__image" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "cart-item__article" };
const _hoisted_5 = { class: "cart-item__sku" };
const _hoisted_6 = { class: "cart-item__controls" };
import { ref } from 'vue';
import productUtils from '@astina/paloma-shop-common-ui/src/services/ProductUtils';
import CartItemControls from "./CartItemControls.vue";
import config from '../services/PortalConfig';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShoppingCartItem',
    props: {
        item: {},
        taxIncluded: { type: Boolean }
    },
    emits: [
        'item-quantity-change',
        'item-params-change',
        'item-remove'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const image = ref((props.item.variant && productUtils.createFirstImage(props.item.variant, config.productImages.sizes.thumbnail)) || null);
        function onItemQuantityChange(quantity) {
            emit('item-quantity-change', props.item, quantity);
        }
        function onItemParamsChange(params) {
            emit('item-params-change', props.item, params);
        }
        function onItemRemove() {
            emit('item-remove', props.item);
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (image.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: image.value.url,
                            alt: image.value.title
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true)
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_router_link, {
                        to: { name: 'catalog', query: { sku: __props.item.sku } },
                        class: "cart-item__title"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.item.title), 1)
                        ]),
                        _: 1
                    }, 8, ["to"]),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.item.sku), 1),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(CartItemControls, {
                            item: __props.item,
                            "tax-included": __props.taxIncluded,
                            onItemQuantityChange: onItemQuantityChange,
                            onItemParamsChange: onItemParamsChange,
                            onItemRemove: onItemRemove
                        }, null, 8, ["item", "tax-included"])
                    ])
                ])
            ]));
        };
    }
});
